import React, { useState } from 'react';
import { WizardForm } from '../components/WizardForm';
import { QrCodeIcon, AlertTriangleIcon, CheckCircleIcon, CreditCardIcon, FileTextIcon } from 'lucide-react';
export function SmartPermitIssuance() {
  const [currentStep, setCurrentStep] = useState(0);
  const [formData, setFormData] = useState({
    smartId: '',
    harvesterName: '',
    resource: '',
    compartment: '',
    duration: '',
    paymentStatus: 'pending',
    // Three-Gate Check Status
    banPeriod: false,
    blacklist: false,
    blcExpiry: false,
    activeTrip: false,
    quotaReached: false
  });
  const wizardSteps = [{
    title: 'Scan Smart ID',
    description: 'Scan Harvester ID'
  }, {
    title: 'Permit Details',
    description: 'Resource & Compartment'
  }, {
    title: 'Three-Gate Check',
    calculate: true,
    description: 'System validation engine'
  }, {
    title: 'Payment & Issue',
    description: 'Confirm and generate'
  }];
  const runValidationEngine = () => {
    // Simulate validation logic
    setFormData(prev => ({
      ...prev,
      banPeriod: prev.resource === 'Honey' && new Date().getMonth() > 5,
      blacklist: Math.random() > 0.95,
      blcExpiry: Math.random() > 0.95,
      activeTrip: Math.random() > 0.9,
      quotaReached: Math.random() > 0.95
    }));
  };
  const isBlocked = formData.banPeriod || formData.blacklist || formData.blcExpiry || formData.activeTrip || formData.quotaReached;
  return <div className="space-y-6" data-id="element-2581" data-mp="1ky7of8hdxbsr">
      <div data-id="element-2582" data-mp="1kz92lltp6eep">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-2583" data-mp="1ywpbr53doma5">
          Smart Permit Issuance
        </h1>
        <p className="text-sm text-gray-600 mt-1" data-id="element-2584" data-mp="1uv3sn2093bri">
          Resource-specific permit generation with automated validation engine
        </p>
      </div>

      <WizardForm steps={wizardSteps} currentStep={currentStep} onStepChange={step => {
      if (step === 2 && currentStep === 1) {
        runValidationEngine();
      }
      setCurrentStep(step);
    }} onSubmit={() => {
      alert('Permit Generated Successfully with QR Code!');
      setCurrentStep(0);
      setFormData({
        smartId: '',
        harvesterName: '',
        resource: '',
        compartment: '',
        duration: '',
        paymentStatus: 'pending',
        banPeriod: false,
        blacklist: false,
        blcExpiry: false,
        activeTrip: false,
        quotaReached: false
      });
    }} data-id="element-2585" data-mp="3aa9icf1jqtts">
        {currentStep === 0 && <div className="space-y-6" data-id="element-2586" data-mp="1t8qmmmqms9y1">
            <div className="bg-gray-50 border-2 border-dashed border-gray-300 rounded-xl p-8 text-center" data-id="element-2587" data-mp="1t7pasg1sjjf9">
              <QrCodeIcon size={48} className="mx-auto text-gray-400 mb-4" data-id="element-2588" data-mp="11ice761dzptr" />
              <h3 className="text-lg font-medium text-gray-900 mb-2" data-id="element-2589" data-mp="11i42vikwwsko">
                Scan Harvester Smart ID
              </h3>
              <p className="text-sm text-gray-500 mb-6" data-id="element-2590" data-mp="y0gdrvr9safu">
                Use the RFID scanner or enter the ID manually
              </p>
              <div className="max-w-xs mx-auto flex gap-2" data-id="element-2591" data-mp="t2etx8m0s73b">
                <input type="text" value={formData.smartId} onChange={e => setFormData({
              ...formData,
              smartId: e.target.value
            })} placeholder="Enter Smart ID..." className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2592" data-mp="ozql30xb306c" />
                <button onClick={() => setFormData({
              ...formData,
              harvesterName: 'Rahim Uddin (Verified)'
            })} className="px-4 py-2 bg-[#1B5E20] text-white rounded-lg hover:bg-[#2E7D32]" data-id="element-2593" data-mp="59oj52purtum">
                  Verify
                </button>
              </div>
            </div>
            {formData.harvesterName && <div className="bg-green-50 border border-green-200 rounded-lg p-4 flex items-center gap-3" data-id="element-2594" data-mp="1wc11qgz0kjet">
                <CheckCircleIcon className="text-green-600" data-id="element-2595" data-mp="1hnwo3retiy2w" />
                <span className="font-medium text-green-900" data-id="element-2596" data-mp="1mmznav84aa2y">
                  {formData.harvesterName}
                </span>
              </div>}
          </div>}

        {currentStep === 1 && <div className="space-y-4" data-id="element-2597" data-mp="1cqehi7o9wuy2">
            <div data-id="element-2598" data-mp="1cn8rmq7tlp1a">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2599" data-mp="ypk75jho0jwr">
                Resource Type *
              </label>
              <select value={formData.resource} onChange={e => setFormData({
            ...formData,
            resource: e.target.value
          })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2600" data-mp="13pq0d43l2egy">
                <option value="" data-id="element-2601" data-mp="hgrn37vlnxnx">Select Resource</option>
                <option value="Fish" data-id="element-2602" data-mp="hi2mkvi0ij98">Fish</option>
                <option value="Honey" data-id="element-2603" data-mp="w5e0h41o2fci">Honey</option>
                <option value="Wood" data-id="element-2604" data-mp="w78lsjguo9h4">Wood</option>
                <option value="Golpata" data-id="element-2605" data-mp="re5p42gs0jwp">Golpata</option>
              </select>
            </div>
            <div className="grid grid-cols-2 gap-4" data-id="element-2606" data-mp="15513fua1nt7o">
              <div data-id="element-2607" data-mp="157wzte68u9u0">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2608" data-mp="106r73gcl2mkh">
                  Forest Compartment *
                </label>
                <select value={formData.compartment} onChange={e => setFormData({
              ...formData,
              compartment: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2609" data-mp="1f2ozqonat8ry">
                  <option value="" data-id="element-2610" data-mp="5gcr43qybhqz">Select Compartment</option>
                  <option value="C-12" data-id="element-2611" data-mp="9gda81ozwh4d">Compartment 12</option>
                  <option value="C-14" data-id="element-2612" data-mp="9ipmpzbzhza1">Compartment 14</option>
                  <option value="C-21" data-id="element-2613" data-mp="eeofdz4ci3g9">Compartment 21</option>
                </select>
              </div>
              <div data-id="element-2614" data-mp="jflxkbpcuxhr">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2615" data-mp="jg41zvm68i0r">
                  Duration (Days) *
                </label>
                <input type="number" value={formData.duration} onChange={e => setFormData({
              ...formData,
              duration: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2616" data-mp="sf9236ddsjf1" />
              </div>
            </div>
          </div>}

        {currentStep === 2 && <div className="space-y-6" data-id="element-2617" data-mp="2wlsivoj6v7nm">
            <h3 className="font-bold text-gray-900 border-b pb-2" data-id="element-2618" data-mp="2wmtupv813y6e">
              Validation Engine Results
            </h3>

            <div className="grid gap-4" data-id="element-2619" data-mp="2mncv9vjdegiv">
              {/* Three-Gate Check */}
              <div className={`p-4 rounded-lg border flex items-start gap-3 ${formData.banPeriod ? 'bg-red-50 border-red-200' : 'bg-green-50 border-green-200'}`} data-id="element-2620" data-mp="2mpfjqb4vk1lh">
                {formData.banPeriod ? <AlertTriangleIcon className="text-red-600 mt-0.5" size={20} data-id="element-2621" data-mp="3acdwaxpvipe4" /> : <CheckCircleIcon className="text-green-600 mt-0.5" size={20} data-id="element-2622" data-mp="35k48bn8bjzeh" />}
                <div data-id="element-2623" data-mp="1y5k307nsb84">
                  <div className={`font-semibold ${formData.banPeriod ? 'text-red-900' : 'text-green-900'}`} data-id="element-2624" data-mp="1yoqpkruzd6u">
                    1. Ban Period Check
                  </div>
                  <div className={`text-sm ${formData.banPeriod ? 'text-red-700' : 'text-green-700'}`} data-id="element-2625" data-mp="31m3xd1sjsdzt">
                    {formData.banPeriod ? `Active ban period for ${formData.resource}. Issuance blocked.` : 'No active ban period.'}
                  </div>
                </div>
              </div>

              <div className={`p-4 rounded-lg border flex items-start gap-3 ${formData.blacklist ? 'bg-red-50 border-red-200' : 'bg-green-50 border-green-200'}`} data-id="element-2626" data-mp="3lcpfab63bymx">
                {formData.blacklist ? <AlertTriangleIcon className="text-red-600 mt-0.5" size={20} data-id="element-2627" data-mp="3gd4edv7d1g7k" /> : <CheckCircleIcon className="text-green-600 mt-0.5" size={20} data-id="element-2628" data-mp="1zx9zdmjxcso5" />}
                <div data-id="element-2629" data-mp="1xdx2kgy6ltq9">
                  <div className={`font-semibold ${formData.blacklist ? 'text-red-900' : 'text-green-900'}`} data-id="element-2630" data-mp="1xddhwsh5cr8j">
                    2. Blacklist Check
                  </div>
                  <div className={`text-sm ${formData.blacklist ? 'text-red-700' : 'text-green-700'}`} data-id="element-2631" data-mp="26el62hpy8bow">
                    {formData.blacklist ? 'Harvester is blacklisted.' : 'Harvester is clear.'}
                  </div>
                </div>
              </div>

              <div className={`p-4 rounded-lg border flex items-start gap-3 ${formData.blcExpiry ? 'bg-red-50 border-red-200' : 'bg-green-50 border-green-200'}`} data-id="element-2632" data-mp="1ng8yv1illbvy">
                {formData.blcExpiry ? <AlertTriangleIcon className="text-red-600 mt-0.5" size={20} data-id="element-2633" data-mp="uywl1vw99mqq" /> : <CheckCircleIcon className="text-green-600 mt-0.5" size={20} data-id="element-2634" data-mp="2l016j3dnfc22" />}
                <div data-id="element-2635" data-mp="2g1hfiok77a2u">
                  <div className={`font-semibold ${formData.blcExpiry ? 'text-red-900' : 'text-green-900'}`} data-id="element-2636" data-mp="2fz512ldnfhuj">
                    3. BLC Expiry Check
                  </div>
                  <div className={`text-sm ${formData.blcExpiry ? 'text-red-700' : 'text-green-700'}`} data-id="element-2637" data-mp="2216ptoumk1j9">
                    {formData.blcExpiry ? 'Associated BLC is expired.' : 'BLC is valid.'}
                  </div>
                </div>
              </div>

              {/* Additional Policies */}
              <div className={`p-4 rounded-lg border flex items-start gap-3 ${formData.activeTrip ? 'bg-orange-50 border-orange-200' : 'bg-green-50 border-green-200'}`} data-id="element-2638" data-mp="1na7mas8nc36j">
                {formData.activeTrip ? <AlertTriangleIcon className="text-orange-600 mt-0.5" size={20} data-id="element-2639" data-mp="3pzqwob4tw1e8" /> : <CheckCircleIcon className="text-green-600 mt-0.5" size={20} data-id="element-2640" data-mp="2u8e7yukyhvu" />}
                <div data-id="element-2641" data-mp="7s1lkv7mdhxp">
                  <div className={`font-semibold ${formData.activeTrip ? 'text-orange-900' : 'text-green-900'}`} data-id="element-2642" data-mp="7r8ka9rfjkmy">
                    One-Trip Policy
                  </div>
                  <div className={`text-sm ${formData.activeTrip ? 'text-orange-700' : 'text-green-700'}`} data-id="element-2643" data-mp="3b7p296lj20ll">
                    {formData.activeTrip ? 'Previous trip not marked returned. Cannot issue new permit.' : 'No active trips.'}
                  </div>
                </div>
              </div>

              <div className={`p-4 rounded-lg border flex items-start gap-3 ${formData.quotaReached ? 'bg-orange-50 border-orange-200' : 'bg-green-50 border-green-200'}`} data-id="element-2644" data-mp="2shqtspdti5hf">
                {formData.quotaReached ? <AlertTriangleIcon className="text-orange-600 mt-0.5" size={20} data-id="element-2645" data-mp="8hx19v90cwlw" /> : <CheckCircleIcon className="text-green-600 mt-0.5" size={20} data-id="element-2646" data-mp="4i61x35f185r" />}
                <div data-id="element-2647" data-mp="37xtx0jk2ltd6">
                  <div className={`font-semibold ${formData.quotaReached ? 'text-orange-900' : 'text-green-900'}`} data-id="element-2648" data-mp="37yd22zomgn9s">
                    Resource Quota
                  </div>
                  <div className={`text-sm ${formData.quotaReached ? 'text-orange-700' : 'text-green-700'}`} data-id="element-2649" data-mp="3gzjo1oa1iqaf">
                    {formData.quotaReached ? 'Station limit reached for this resource.' : 'Quota available.'}
                  </div>
                </div>
              </div>
            </div>

            {isBlocked && <div className="bg-red-100 text-red-800 p-4 rounded-lg font-bold text-center" data-id="element-2650" data-mp="upsoflrhtf02">
                ISSUANCE BLOCKED: Please resolve the flagged issues above.
              </div>}
          </div>}

        {currentStep === 3 && <div className="space-y-6" data-id="element-2651" data-mp="1nezvj950jcwx">
            {!isBlocked ? <>
                <div className="bg-blue-50 p-6 rounded-lg border border-blue-200 flex items-center justify-between" data-id="element-2652" data-mp="1sc9jslgo1ij6">
                  <div data-id="element-2653" data-mp="1doep4zj3l43g">
                    <h4 className="font-bold text-blue-900 flex items-center gap-2" data-id="element-2654" data-mp="1inrlqbzrtpj8">
                      <CreditCardIcon size={20} data-id="element-2655" data-mp="1ilop39444y5j" /> Payment Confirmation
                    </h4>
                    <p className="text-sm text-blue-700 mt-1" data-id="element-2656" data-mp="26b97nqwcttea">
                      Total Fee: ৳ 1,250
                    </p>
                  </div>
                  <button onClick={() => setFormData({
              ...formData,
              paymentStatus: 'paid'
            })} className={`px-6 py-2 rounded-lg font-medium transition-colors ${formData.paymentStatus === 'paid' ? 'bg-green-600 text-white' : 'bg-blue-600 text-white hover:bg-blue-700'}`} data-id="element-2657" data-mp="mihpgeuep0t4">
                    {formData.paymentStatus === 'paid' ? 'Paid ✓' : 'Confirm Payment'}
                  </button>
                </div>

                {formData.paymentStatus === 'paid' && <div className="bg-gray-50 border-2 border-dashed border-gray-300 rounded-xl p-8 text-center animate-in fade-in" data-id="element-2658" data-mp="rhm2xhod5kp9">
                    <FileTextIcon size={48} className="mx-auto text-[#1B5E20] mb-4" data-id="element-2659" data-mp="1oxi14j9nidkq" />
                    <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-2660" data-mp="1rh5zh3ppqdgp">
                      Digital Permit Ready
                    </h3>
                    <p className="text-sm text-gray-500 mb-4" data-id="element-2661" data-mp="1whafytqmf86x">
                      Permit will be generated with a secure QR code and digital
                      signature.
                    </p>
                    <div className="inline-block bg-white px-4 py-2 rounded-lg border border-gray-200 font-mono font-bold text-lg text-gray-900" data-id="element-2662" data-mp="26fgklj3tasfh">
                      PRM-2024-
                      {Math.floor(Math.random() * 10000).toString().padStart(4, '0')}
                    </div>
                  </div>}
              </> : <div className="text-center py-8 text-red-600 font-bold" data-id="element-2663" data-mp="2p4dcxhfnfav2">
                Cannot proceed. Validation checks failed.
              </div>}
          </div>}
      </WizardForm>
    </div>;
}